/** PWA app-icon badge (Badging API). The badge mirrors bookings awaiting provider review. */

export function canUseAppBadge(): boolean {
  return typeof navigator !== 'undefined' && 'setAppBadge' in navigator && 'clearAppBadge' in navigator
}

/** Sets the badge to `count`, or clears it when nothing is pending. */
export async function syncAppBadge(count: number): Promise<void> {
  if (!canUseAppBadge()) {
    return
  }

  try {
    if (count > 0) {
      await navigator.setAppBadge(Math.floor(count))
    } else {
      await navigator.clearAppBadge()
    }
  } catch {
    // Badging API rejects when notification permission is missing or the app is not installed.
  }
}
